<div class="sc-dr-rank-grid">
    <div
        class="my-3 mx-auto text-center"
        *ngIf="!model?.rows || model?.rows.length === 0"
    >
        {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>
    <div class="gridContainer">
        <div
            ngGrid
            [rendererOptions]="_rendererOpts"
            [selectTemplate]="_selectTpl"
            [rows]="model?.rows"
            [sortDefs]="model?.sortDefs"
            (willInflate)="_onWillInflate()"
            (didInflate)="_onDidInflate()"
            *ngIf="model?.rows?.length !== 0"
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>
            <ng-template
                gridContent
                data-type="row"
            >
                <div></div>
            </ng-template>
            <ng-template
                let-c="c"
                #sortTpl
            >
                <button class="align-self-end">
                    <cmps-icon
                        class="cmps-cdk-fill-white"
                        [svgIcon]="
                            model?.sortDefs[0].order === _SortOrder.ASC
                                ? 'chevron-up'
                                : 'chevron-down'
                        "
                        *ngIf="
                            model?.sortDefs &&
                            model?.sortDefs.length &&
                            model?.sortDefs[0].columnId === c.id
                        "
                    ></cmps-icon>
                    <cmps-icon
                        class="cmps-cdk-fill-white"
                        svgIcon="unfold-more-horizontal"
                        *ngIf="
                            !model?.sortDefs ||
                            !model?.sortDefs.length ||
                            model?.sortDefs[0].columnId !== c.id
                        "
                    ></cmps-icon>
                </button>
            </ng-template>
            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
                let-ctx="ctx"
            >
                <div [ngSwitch]="ctx.type">
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.DIRECT_REPORTS"
                        [cmpsTooltipTrigger]="
                            _i18n._9116_DIRECTREPORTS_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ _i18n._9128_DIRECTREPORTS | translate }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>

                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_NAME"
                        [cmpsTooltipTrigger]="
                            _i18n._9117_SUPERGROUP_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ _i18n._67_SUPERGROUP | translate }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.PERIOD"
                        [cmpsTooltipTrigger]="
                            _i18n._9118_PERIOD_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ _i18n._773_PERIOD | translate }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.ADJUSTED_POINTS"
                        [cmpsTooltipTrigger]="
                            _i18n._9119_OVERALL_SCORE_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{ _i18n._962_OVERALL_SCORE | translate }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_OVERALL_RANK"
                        [cmpsTooltipTrigger]="
                            _i18n._9120_SUPERGROUP_OVERALL_RANK_DESCRIPTION
                                | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{
                            _i18n._9124_SUPERGROUP_OVERALL_RANK | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.SITE_SUPERGROUP_RANK"
                        [cmpsTooltipTrigger]="
                            _i18n._9121_SITE_SUPERGROUP_RANK_DESCRIPTION
                                | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{
                            _i18n._9125_SITE_SUPERGROUP_RANK | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.PEER_GROUP_OVERALL_RANK"
                        [cmpsTooltipTrigger]="
                            _i18n._9901_PEER_GROUP_OVERALL_RANK_DESCRIPTION
                                | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{
                            _i18n._9899_PEER_GROUP_OVERALL_RANK | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.LOB_OVERALL_RANK"
                        [cmpsTooltipTrigger]="
                            _i18n._9902_LOB_OVERALL_RANK_DESCRIPTION | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{
                            _i18n._9900_LOB_OVERALL_RANK | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.ROLE_OVERALL_RANK"
                        [cmpsTooltipTrigger]="
                            _i18n._9122_ROLE_OVERALL_RANK_DESCRIPTION
                                | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{
                            _i18n._9126_ROLE_OVERALL_RANK | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                    <div
                        class="sc-grid-table-header"
                        (click)="_onSortClick(c)"
                        *ngSwitchCase="_ColumnType.ROLE_BY_REGION_RANK"
                        [cmpsTooltipTrigger]="
                            _i18n._9123_ROLE_BY_REGION_RANK_DESCRIPTION
                                | translate
                        "
                        trigger="hover"
                        [ngStyle]="{ 'background-color': headerColour }"
                    >
                        <span>{{
                            _i18n._9127_ROLE_BY_REGION_RANK | translate
                        }}</span>
                        <div class="sc-grid-table-header-sorting-icon">
                            <ng-container
                                *ngTemplateOutlet="sortTpl; context: { c: c }"
                            ></ng-container>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="content"
                let-c="c"
                let-ctx="ctx"
            >
                <div [ngSwitch]="c.ctx.type">
                    <div
                        class="sc-grid-table-content-pillar"
                        *ngSwitchCase="_ColumnType.DIRECT_REPORTS"
                    >
                        <span>{{ ctx.data.directReport }}</span>
                        <cmps-icon
                            class="cell-icon"
                            svgIcon="open-in-new"
                            (click)="_onDRScorecardSelect(ctx.data)"
                            [cmpsTooltipTrigger]="
                                _i18n._9980_LAUNCH_SCORECARD | translate
                            "
                            trigger="hover"
                        ></cmps-icon>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_NAME"
                    >
                        <span>{{ ctx.data.subSuperGroupName }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.PERIOD"
                    >
                        <span>{{
                            (ctx.data?.period | cmpsGridPeriod) || '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.ADJUSTED_POINTS"
                    >
                        <span>{{
                            ctx.data.overallScore
                                ? (ctx.data.overallScore | number: '1.2-2')
                                : '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.SUPERGROUP_OVERALL_RANK"
                    >
                        <span>{{
                            ctx.data.superGroupOverallRank
                                ? ctx.data.superGroupOverallRank
                                : '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.SITE_SUPERGROUP_RANK"
                    >
                        <span>{{
                            ctx.data.siteSuperGroupRank
                                ? ctx.data.siteSuperGroupRank
                                : '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.PEER_GROUP_OVERALL_RANK"
                    >
                        <span>{{
                            ctx.data.peerGroupOverallRank
                                ? ctx.data.peerGroupOverallRank
                                : '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.LOB_OVERALL_RANK"
                    >
                        <span>{{
                            ctx.data.lobOverallRank
                                ? ctx.data.lobOverallRank
                                : '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.ROLE_OVERALL_RANK"
                    >
                        <span>{{
                            ctx.data.roleOverallRank
                                ? ctx.data.roleOverallRank
                                : '-'
                        }}</span>
                    </div>
                    <div
                        class="sc-grid-table-content"
                        *ngSwitchCase="_ColumnType.ROLE_BY_REGION_RANK"
                    >
                        <span>{{
                            ctx.data.roleByRegionRank
                                ? ctx.data.roleByRegionRank
                                : '-'
                        }}</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
